import IconNavRight from '../../../assets/svg/IconNavRight';
import { useOrientation } from '../../../boot/OrientationContext';
import { neutralDark, white } from '../../../constants/color';
import { GET_LAYOUT_MAX_WIDTH } from '../../../constants/layout';
import { translate } from '../../../i18n';
import { ListLoadingTypes } from '../../../types/Common';
import { navigate } from '../../../utils/navigationService';
import routeUtils from '../../../utils/routes';
import { S } from './styles';

const start = { x: 0, y: 0 };
const end = { x: 1, y: 0 };
/* FIXME: get colors from api */
const colors = ['#ee6831', '#f45945'];
const hitSlop = { top: 10, right: 10, bottom: 10, left: 10 };

interface Props {
  isFetching: boolean;
  loadingType: ListLoadingTypes;
  isNewFetching: boolean;
  isNewCustomer: boolean;
  onBoardingIdList: string[];
}

const watchMoreLogData = [
  {
    actionName: 'click_others',
    eventCategory: 'observation metric',
    eventLabel: 'index_newuserWatchmoreBtnTop',
  },
];

export default ({
  isFetching,
  isNewFetching,
  isNewCustomer,
  onBoardingIdList,
}: Props) => {
  useOrientation();

  const onPressMore = () => {
    navigate('OnboardingPage');
  };

  if (!isNewCustomer || !onBoardingIdList.length) {
    return null;
  }

  return (
    <S.TitleSection
      start={start}
      end={end}
      colors={
        isNewFetching
          ? // 只用 ['transparent'] 的話沒辦法套用到 style
            ['transparent', 'transparent']
          : colors
      }
      isNewFetching={isNewFetching}
      width={GET_LAYOUT_MAX_WIDTH()}
    >
      <S.TitleText isNewFetching={isNewFetching}>
        {translate('new-friends-gifts')}
      </S.TitleText>
      {!isFetching && (
        <S.WatchMore
          accessibilityRole="link"
          href={routeUtils.compileToPath('OnboardingPage')}
          logData={watchMoreLogData}
          onPress={onPressMore}
          hitSlop={hitSlop}
          testID="WatchMoreLink"
        >
          <S.WatchMoreText isNewFetching={isNewFetching}>
            {translate('watch-more')}
          </S.WatchMoreText>
          <IconNavRight
            size={14}
            fillColor={isNewFetching ? neutralDark : white}
          />
        </S.WatchMore>
      )}
    </S.TitleSection>
  );
};
